module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_02-28acb8fa67afbe004aa821d5cd469680.png";